import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../core/http.service';
import { environment } from '@base/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { Filter } from 'src/app/models/filters.model';

@Injectable({
  providedIn: 'root',
})
export class RrhhTeamsListService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/rrhh/teams';
    this.baseUrl = environment.apiEndpoint;
  }

  async getTeamList(
    id: string,
    currencyHeader: string,
    filter: Filter = new Filter()
  ): Promise<any> {
    try {
      const data = await firstValueFrom(
        this.getTeamListObservable(id, currencyHeader, filter)
      );
      return JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  getTeamListObservable(
    id: string,
    currencyHeader: string,
    filter: Filter = new Filter()
  ): Observable<any> {
    const queryString = filter.toQueryString();

    const headers = new HttpHeaders().set('currency', currencyHeader);
    const options = { headers };

    return this.http.get(
      this.baseUrl + this.url + `/${id}?${queryString}`,
      options
    );
  }

  changeAgentDischargeDate(dto: {agencyId: number, loggedUser: string, newDischargeDate: string, id: number, }): Observable<any> {
    const URL = `${this.baseUrl}${this.url}/newDischargeDate`;
    return this.http.put(URL, dto);
  }
  
}
